import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../config';

function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/v1/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-panel min-h-screen flex items-center justify-center font-sans px-4">
      <div className="bg-surface border border-edge rounded-2xl p-8 sm:p-10 w-full max-w-[360px]">
        <h1 className="text-accent text-xl font-extrabold mb-1">{t('common.appName')}</h1>
        <p className="text-muted text-[13px] mb-7">{t('forgotPassword.subtitle')}</p>

        {sent ? (
          <p className="text-accent text-[13px] mb-6">{t('forgotPassword.genericMessage')}</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <label className="text-[#888] text-xs block mb-1.5">{t('login.email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-surfaceAlt border border-edge rounded-lg px-3 py-2.5 text-white text-sm mb-5 box-border focus:outline-none focus:border-accent"
            />
            {error && <p className="text-red-400 text-[13px] mb-4">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-accent border-none rounded-lg py-3 text-panel text-sm font-bold cursor-pointer ${loading ? 'opacity-70' : ''}`}
            >
              {loading ? t('forgotPassword.sending') : t('forgotPassword.sendButton')}
            </button>
          </form>
        )}

        <p className="text-muted text-xs mt-5 text-center">
          <span className="text-accent cursor-pointer" onClick={() => navigate('/login')}>
            {t('forgotPassword.backToLogin')}
          </span>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;